import api from './api';

export const getMyPets          = ()           => api.get('/api/pets');
export const createPet          = data         => api.post('/api/pets', data);
export const getPet             = id           => api.get(`/api/pets/${id}`);
export const updatePet          = (id, data)   => api.put(`/api/pets/${id}`, data);
export const deletePet          = id           => api.delete(`/api/pets/${id}`);
export const regeneratePetQR    = id           => api.post(`/api/pets/${id}/regenerate-qr`);
export const registerAssetToPet = (id, assetId)=> api.post(`/api/pets/${id}/register-asset`, { assetId });
export const getPublicPetProfile= qrCodeId     => api.get(`/api/pets/public/${qrCodeId}`);
